module.exports = __webpack_public_path__ + "static/media/logo-super.12f75ddd.svg";